module.exports = __webpack_public_path__ + "static/media/cbs-tv-two-girls.119622ec.png";